import { useRecordContext } from 'react-admin';
import { Chip } from '@mui/material';
import { useObjectStatuses } from '../../hooks';

export const StatusChip = () => {
	const record = useRecordContext();
	const { getObjectStatus } = useObjectStatuses();

	if (!record) return null;

	const { status_data } = record;

	const { color, name } = getObjectStatus(status_data.status_id || 1) || {};
	// debugger;

	return (
		<Chip
			label={name}
			size="small"
			sx={{
				backgroundColor: color,
				fontWeight: 'bold',
				color: 'primary.contrastText'
			}}
		/>
	);
};
